import { Autocomplete, ListItemText, TextField } from "@mui/material"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useDebounce } from "use-debounce"
import { getOrganizations, organizationSelectors } from "../../../../redux/dicts/organizationsSlice"

const OrganizationSearch = ({ initialSearch, onChange, error, lookupField = "name", inputProps, ...rest }) => {

    const options = useSelector(organizationSelectors.selectAll)
    const isLoading = useSelector(x => x.dicts.organizations.isLoading)

    const dispatch = useDispatch()

    const [inputValue, setInputValue] = useState(initialSearch)

    React.useEffect(() => {
        setInputValue(initialSearch || "")
    }, [initialSearch])

    const [debouncedInputValue] = useDebounce(inputValue, 1000)

    React.useEffect(() => {
        dispatch(getOrganizations({ search: debouncedInputValue })).unwrap()
    }, [dispatch, debouncedInputValue])

    const handleChange = (_, value) => {
        setInputValue(value?.name ?? value?.sname ?? "")
        onChange(value?.[lookupField])
    }

    return <Autocomplete
        options={options}
        getOptionLabel={option => option?.name ?? option?.sname}
        loading={isLoading}
        inputValue={inputValue}
        onChange={handleChange}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        renderOption={({ key, ...props }, option) => <ListItemText
            {...props}
            key={option.id}
            primary={option.name}
            secondary={option.address}
            sx={{ flexDirection: "column", alignItems: "start !important" }}
        />}
        label="Название организации"
        renderInput={props => <TextField
            helperText="Для поиска начните вводить название организации"
            error={error}
            onChange={e => { setInputValue(e.target.value) }}
            {...inputProps}
            {...props}
        />}
        {...rest}
    />
}

export default OrganizationSearch